import ApiClient from './ApiClient';

class BroadcastBlacklistAPI extends ApiClient {
  constructor() {
    super('broadcast_blacklist_entries', { accountScoped: true });
  }
}

export default new BroadcastBlacklistAPI();
